<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="发布人" prop="userId">
                <el-input v-model="query.userId" placeholder="搜索用户手机号或ID" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="帖子标题" prop="title">
                <el-input v-model="query.title" placeholder="搜索帖子标题" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="发布时间" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="帖子状态" prop="shelfStatus">
                <el-select v-model="query.shelfStatus" placeholder="请选择帖子状态">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="下架" value="0"></el-option>
                </el-select>
            </el-form-item>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="帖子ID" align="center" prop="id"></el-table-column>
            <el-table-column label="发布时间" align="center" prop="publishTime"></el-table-column>
            <el-table-column label="发布人" align="center" prop="userName"></el-table-column>
            <el-table-column label="状态" align="center" prop="shelfStatus">
                <template slot-scope="{ row }">
                    <el-tag type="success" v-if="row.shelfStatus === 1">展示中</el-tag>
                    <el-tag type="info" v-else>已下架</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="140">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/community/post/detail')" :underline="false" type="primary" @click="handleDetail(row)">
                        详情
                    </el-link>
                    <el-link v-if="permission('/community/post/delete')" :underline="false" type="danger" @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/community/post";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                userId: "",
                title: "",
                recommendWeight: 0,
                auditStatus: 2,
                date: [],
                shelfStatus: undefined,
                pageNo: 1,
                pageSize: 10
            },
        };
    },
    mixins: [listMixin],
    methods: {
        search() {
            const num = /^[\d]*$/;
            if (!num.test(this.query.userId)) {
                this.$message.error('用户手机号或ID格式不正确')
                return;
            }
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date[0] ? this.query.date[0] + ' 00:00:00' : '',
                endTime: this.query.date[1] ? this.query.date[1] + ' 23:59:59' : '',
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleDetail(row) {
            this.$router.push({ path: "/community/post/detail", query: { id: row.id } });
        },
        handleDelete(row) {
            this.$confirm('确定删除该帖子吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        }
    },
};
</script>